export default {
  verificado: false,
  temPendencia: false,
  pendenciaAtual: null
};
